"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineChangeType = exports.ChangeType = void 0;
function valueIsEmpty(value) {
    return Boolean(value) === false || (value instanceof Array && value.length === 0);
}
var ChangeType;
(function (ChangeType) {
    ChangeType[ChangeType["Empty"] = 0] = "Empty";
    ChangeType[ChangeType["Changed"] = 1] = "Changed";
    ChangeType[ChangeType["Added"] = 2] = "Added";
    ChangeType[ChangeType["Removed"] = 3] = "Removed";
})(ChangeType || (exports.ChangeType = ChangeType = {}));
const determineChangeType = (previousValue, currentValue) => {
    // Empty change is basically insignificant (eg: null => empty string, empty string => 0, or [] => null, and vice-versa)
    if (valueIsEmpty(previousValue) && valueIsEmpty(currentValue)) {
        return ChangeType.Empty;
    }
    if (valueIsEmpty(previousValue) && !valueIsEmpty(currentValue)) {
        return ChangeType.Added;
    }
    if (!valueIsEmpty(previousValue) && valueIsEmpty(currentValue)) {
        return ChangeType.Removed;
    }
    return ChangeType.Changed;
};
exports.determineChangeType = determineChangeType;
//# sourceMappingURL=ValueChange.js.map